module.exports = __webpack_public_path__ + "static/media/Logo TNP.f8abec12.jpg";